import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from '@app/store/reducers/auth';
import { uiSlice } from '@app/store/reducers/ui';
import { createLogger } from 'redux-logger';
import { menuSlice } from './reducers/menu';
import { loadingSlide } from './reducers/loading';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        ui: uiSlice.reducer,
        menu: menuSlice.reducer,
        loading: loadingSlide.reducer,
    },
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware().concat(createLogger())
    ]
});

export default store;
